import React from "react";
import { Copy } from "components/components/atoms";
import styled from "styled-components";
import cx from "classnames";
import useNewColorSchemaOptions from "utils/hooks/useNewColorSchemaOptions";
import RulerIcon from "components/icons/Ruler";
import HomeIcon from "components/icons/Home";
import BedIcon from "components/icons/Bed";
import GarageIcon from "components/icons/Garage";
import StorieIcon from "components/icons/Storie";
import BathIcon from "components/icons/Bath";
import HalfBathIcon from "components/icons/HalfBath";
import useBreakpoint from "utils/hooks/useBreakpoint";

const Ruler = styled(RulerIcon)`
  ${({ showNewSchemaColor, color }) => showNewSchemaColor && `color: ${color};`}
`;
const Home = styled(HomeIcon)`
  ${({ showNewSchemaColor, color }) => showNewSchemaColor && `color: ${color};`}
`;
const Bed = styled(BedIcon)`
  ${({ showNewSchemaColor, color }) => showNewSchemaColor && `color: ${color};`}
`;
const Garage = styled(GarageIcon)`
  ${({ showNewSchemaColor, color }) => showNewSchemaColor && `color: ${color};`}
`;
const Storie = styled(StorieIcon)`
  ${({ showNewSchemaColor, color }) => showNewSchemaColor && `color: ${color};`}
`;
const Bath = styled(BathIcon)`
  ${({ showNewSchemaColor, color }) => showNewSchemaColor && `color: ${color};`}
`;
const HalfBath = styled(HalfBathIcon)`
  ${({ showNewSchemaColor, color }) => showNewSchemaColor && `color: ${color};`}
`;

const getRanges = (ranges) => {
  if (ranges && ranges.length > 4) {
    const r = ranges.split(" - ");
    if (r[0] === "0" && r[1] === "0") return "";
    if (r[0] === r[1]) return r[0];
  }
  return typeof ranges !== "undefined" ? ranges : "";
};

const getHomeTypesList = (str) => {
  if (str && str.length > 0) {
    const homeTypesList = str.split("|");
    let newList = "";
    homeTypesList.forEach((h, i) => {
      if (i < homeTypesList.length - 1) newList = newList + h + " | ";
      else newList = newList + h;
    });
    return newList;
  }
  return str;
};

const CommunityProductOverviewHomeDetails = ({ homeDetails }) => {
  const breakpoint = useBreakpoint(
    typeof window !== "undefined" && window.innerWidth
  );
  const isMobile = ["sm", "xs"].includes(breakpoint);
  const {
    newSchemaTextColorHexaCode,
    showNewSchemaColor,
  } = useNewColorSchemaOptions();

  //render Home Details section
  const renderHomeDetailsMobile = () => (
    <>
      <div className="flex flex-col md:flex-row text-left w-full md:mb-2">
        {homeDetails && homeDetails.homeTypes && (
          <div className="flex flex-row w-full md:flex-col md:w-4/12">
            <div className="flex ">
              <Home
                className={cx("h-6 md:h-12 mr-2", {
                  " text-mattamy-blue": !showNewSchemaColor,
                })}
                showNewSchemaColor={showNewSchemaColor}
                color={newSchemaTextColorHexaCode}
              />
            </div>
            <div className="flex flex-row md:flex-col">
              <Copy
                color={showNewSchemaColor ? newSchemaTextColorHexaCode : "blue"}
                className="md:-mt-2 font-graphie font-bold leading-7"
              >
                {"Home Types: " + homeDetails.homeTypes}
              </Copy>
            </div>
          </div>
        )}

        {homeDetails && getRanges(homeDetails.bedroomRanges) !== "" && (
          <div className="flex flex-row w-full md:flex-col md:w-4/12">
            <div className="flex flex-row md:flex-col">
              <Bed
                className={cx("w-6 md:h-12 mr-2", {
                  " text-mattamy-blue": !showNewSchemaColor,
                })}
                showNewSchemaColor={showNewSchemaColor}
                color={newSchemaTextColorHexaCode}
              />
            </div>
            <div className="flex flex-row md:flex-col">
              <Copy
                color={showNewSchemaColor ? newSchemaTextColorHexaCode : "blue"}
                className="md:-mt-2 font-graphie font-bold leading-7"
              >
                {getRanges(homeDetails.bedroomRanges) + " Bedrooms"}
              </Copy>
            </div>
          </div>
        )}

        {homeDetails && getRanges(homeDetails.fullBathRanges) !== "" && (
          <div className="flex flex-row w-full md:flex-col md:w-4/12">
            <div className="flex flex-row md:flex-col">
              <Bath
                className={cx("w-6 md:h-12 mr-2", {
                  " text-mattamy-blue": !showNewSchemaColor,
                })}
                showNewSchemaColor={showNewSchemaColor}
                color={newSchemaTextColorHexaCode}
              />
            </div>
            <div className="flex flex-row md:flex-col">
              <Copy
                color={showNewSchemaColor ? newSchemaTextColorHexaCode : "blue"}
                className="md:-mt-2 font-graphie font-bold leading-7"
              >
                {getRanges(homeDetails.fullBathRanges) + " Full Bathrooms"}
              </Copy>
            </div>
          </div>
        )}
      </div>

      <div className="flex flex-col md: text-left w-full md:mb-2">
        {homeDetails && getRanges(homeDetails.halfBathRanges) !== "" && (
          <div className="flex flex-row w-full md:flex-col md:w-4/12">
            <div className="flex flex-row md:flex-col">
              <HalfBath
                className={cx("h-6 md:h-12 mr-2", {
                  " text-mattamy-blue": !showNewSchemaColor,
                })}
                showNewSchemaColor={showNewSchemaColor}
                color={newSchemaTextColorHexaCode}
              />
            </div>
            <div className="flex flex-row md:flex-col">
              <Copy
                color={showNewSchemaColor ? newSchemaTextColorHexaCode : "blue"}
                className="md:-mt-2 font-graphie font-bold leading-7"
              >
                {getRanges(homeDetails.halfBathRanges) + " Half Bathrooms"}
              </Copy>
            </div>
          </div>
        )}

        {homeDetails && getRanges(homeDetails.sqFtRanges) !== "" && (
          <div className="flex flex-row w-full md:flex-col md:w-4/12">
            <div className="flex flex-row md:flex-col">
              <Ruler
                className={cx("h-6 md:h-12 mr-2", {
                  " text-mattamy-blue": !showNewSchemaColor,
                })}
                showNewSchemaColor={showNewSchemaColor}
                color={newSchemaTextColorHexaCode}
              />
            </div>
            <div className="flex flex-row md:flex-col">
              <Copy
                color={showNewSchemaColor ? newSchemaTextColorHexaCode : "blue"}
                className="md:-mt-2 font-graphie font-bold leading-7"
              >
                {getRanges(homeDetails.sqFtRanges) + " SQ. FT."}
              </Copy>
            </div>
          </div>
        )}

        {homeDetails && getRanges(homeDetails.storyRanges) !== "" && (
          <div className="flex flex-row w-full md:flex-col md:w-4/12">
            <div className="flex flex-row md:flex-col">
              <Storie
                className={cx("h-6 md:h-12 mr-2", {
                  " text-mattamy-blue": !showNewSchemaColor,
                })}
                showNewSchemaColor={showNewSchemaColor}
                color={newSchemaTextColorHexaCode}
              />
            </div>
            <div className="flex flex-row md:flex-col">
              <Copy
                color={showNewSchemaColor ? newSchemaTextColorHexaCode : "blue"}
                className="md:-mt-2 font-graphie font-bold leading-7"
              >
                {getRanges(homeDetails.storyRanges) + " Stories"}
              </Copy>
            </div>
          </div>
        )}
      </div>

      <div className="flex flex-col md:text-left w-full">
        {homeDetails && getRanges(homeDetails.garageRanges) !== "" && (
          <div className="flex flex-row w-full md:flex-col md:w-4/12">
            <div className="flex flex-row md:flex-col">
              <Garage
                className={cx("h-6 md:h-12 mr-2", {
                  " text-mattamy-blue": !showNewSchemaColor,
                })}
                showNewSchemaColor={showNewSchemaColor}
                color={newSchemaTextColorHexaCode}
              />
            </div>
            <div className="flex flex-row md:flex-col">
              <Copy
                color={showNewSchemaColor ? newSchemaTextColorHexaCode : "blue"}
                className="md:-mt-2 font-graphie font-bold leading-7"
              >
                {getRanges(homeDetails.garageRanges) + " Garages"}
              </Copy>
            </div>
          </div>
        )}
      </div>
    </>
  );
  const renderHomeDetails = () => (
    <>
      <div className="grid grid-cols-3 gap-4">
        {homeDetails &&
          homeDetails.homeTypes &&
          homeDetails.homeTypes.length > 0 && (
            <div className="flex flex-row">
              <div className="flex w-auto mr-2">
                <Home
                  className={cx("h-6 md:h-12 md:w-12 mr-2 ", {
                    " text-mattamy-blue": !showNewSchemaColor,
                  })}
                  showNewSchemaColor={showNewSchemaColor}
                  color={newSchemaTextColorHexaCode}
                />
              </div>
              <div className="flex flex-col w-auto">
                <Copy
                  color={
                    showNewSchemaColor ? newSchemaTextColorHexaCode : "blue"
                  }
                  className=" font-graphie font-bold leading-7"
                  as="h3"
                  tabIndex="0"
                >
                  {"Home Types"}
                </Copy>
                <Copy
                  color={
                    showNewSchemaColor ? newSchemaTextColorHexaCode : "blue"
                  }
                  className="md:-mt-2 font-graphie font-bold leading-7"
                >
                  {getHomeTypesList(homeDetails.homeTypes)}
                </Copy>
              </div>
            </div>
          )}

        {homeDetails && getRanges(homeDetails.bedroomRanges) !== "" && (
          <div className="flex flex-row">
            <div className="flex w-auto mr-2">
              <Bed
                className={cx("w-12 mr-2 ", {
                  " text-mattamy-blue": !showNewSchemaColor,
                })}
                showNewSchemaColor={showNewSchemaColor}
                color={newSchemaTextColorHexaCode}
              />
            </div>
            <div className="flex flex-row md:flex-col">
              <Copy
                color={showNewSchemaColor ? newSchemaTextColorHexaCode : "blue"}
                className=" font-graphie font-bold leading-7"
                as="h3"
                tabIndex="0"
              >
                {"Bedrooms"}
              </Copy>
              <Copy
                color={showNewSchemaColor ? newSchemaTextColorHexaCode : "blue"}
                className="md:-mt-2 font-graphie font-bold leading-7"
              >
                {getRanges(homeDetails.bedroomRanges)}
              </Copy>
            </div>
          </div>
        )}

        {homeDetails && getRanges(homeDetails.fullBathRanges) !== "" && (
          <div className="flex flex-row">
            <div className="flex w-auto mr-2">
              <Bath
                className={cx("h-6 md:h-12 md:w-12 mr-2 ", {
                  " text-mattamy-blue": !showNewSchemaColor,
                })}
                showNewSchemaColor={showNewSchemaColor}
                color={newSchemaTextColorHexaCode}
              />
            </div>
            <div className="flex flex-row md:flex-col">
              <Copy
                color={showNewSchemaColor ? newSchemaTextColorHexaCode : "blue"}
                className=" font-graphie font-bold leading-7"
                as="h3"
                tabIndex="0"
              >
                {"Full Bathrooms"}
              </Copy>
              <Copy
                color={showNewSchemaColor ? newSchemaTextColorHexaCode : "blue"}
                className="md:-mt-2 font-graphie font-bold leading-7"
              >
                {getRanges(homeDetails.fullBathRanges)}
              </Copy>
            </div>
          </div>
        )}

        {homeDetails && getRanges(homeDetails.halfBathRanges) !== "" && (
          <div className="flex flex-row">
            <div className="flex w-auto mr-2">
              <HalfBath
                className={cx("h-6 md:h-12 md:w-12 mr-2 ", {
                  " text-mattamy-blue": !showNewSchemaColor,
                })}
                showNewSchemaColor={showNewSchemaColor}
                color={newSchemaTextColorHexaCode}
              />
            </div>
            <div className="flex flex-row md:flex-col">
              <Copy
                color={showNewSchemaColor ? newSchemaTextColorHexaCode : "blue"}
                className=" font-graphie font-bold leading-7"
                as="h3"
                tabIndex="0"
              >
                {"Half Bathrooms"}
              </Copy>
              <Copy
                color={showNewSchemaColor ? newSchemaTextColorHexaCode : "blue"}
                className="md:-mt-2 font-graphie font-bold leading-7"
              >
                {getRanges(homeDetails.halfBathRanges)}
              </Copy>
            </div>
          </div>
        )}

        {homeDetails && getRanges(homeDetails.sqFtRanges) !== "" && (
          <div className="flex flex-row">
            <div className="flex w-auto mr-2">
              <Ruler
                className={cx("h-6 md:h-12 md:w-12 mr-2 ", {
                  " text-mattamy-blue": !showNewSchemaColor,
                })}
                showNewSchemaColor={showNewSchemaColor}
                color={newSchemaTextColorHexaCode}
              />
            </div>
            <div className="flex flex-col w-auto">
              <Copy
                color={showNewSchemaColor ? newSchemaTextColorHexaCode : "blue"}
                className=" font-graphie font-bold leading-7"
                as="h3"
                tabIndex="0"
              >
                {"SQ. FT."}
              </Copy>
              <Copy
                color={showNewSchemaColor ? newSchemaTextColorHexaCode : "blue"}
                className="md:-mt-2 font-graphie font-bold leading-7"
              >
                {getRanges(homeDetails.sqFtRanges)}
              </Copy>
            </div>
          </div>
        )}

        {homeDetails && getRanges(homeDetails.storyRanges) !== "" && (
          <div className="flex flex-row">
            <div className="flex w-auto mr-2">
              <Storie
                className={cx("h-6 md:h-12 md:w-12 mr-2 ", {
                  " text-mattamy-blue": !showNewSchemaColor,
                })}
                showNewSchemaColor={showNewSchemaColor}
                color={newSchemaTextColorHexaCode}
              />
            </div>
            <div className="flex flex-col w-auto">
              <Copy
                color={showNewSchemaColor ? newSchemaTextColorHexaCode : "blue"}
                className=" font-graphie font-bold leading-7"
                as="h3"
                tabIndex="0"
              >
                {"Stories"}
              </Copy>
              <Copy
                color={showNewSchemaColor ? newSchemaTextColorHexaCode : "blue"}
                className="md:-mt-2 font-graphie font-bold leading-7"
              >
                {getRanges(homeDetails.storyRanges)}
              </Copy>
            </div>
          </div>
        )}

        {homeDetails && getRanges(homeDetails.garageRanges) !== "" && (
          <div className="flex flex-row">
            <div className="flex w-auto mr-2">
              <Garage
                className={cx("h-6 md:h-12 md:w-12 mr-2 ", {
                  " text-mattamy-blue": !showNewSchemaColor,
                })}
                showNewSchemaColor={showNewSchemaColor}
                color={newSchemaTextColorHexaCode}
              />
            </div>
            <div className="flex flex-row md:flex-col">
              <Copy
                color={showNewSchemaColor ? newSchemaTextColorHexaCode : "blue"}
                className=" font-graphie font-bold leading-7"
                as="h3"
                tabIndex="0"
              >
                {"Garages"}
              </Copy>
              <Copy
                color={showNewSchemaColor ? newSchemaTextColorHexaCode : "blue"}
                className="md:-mt-2 font-graphie font-bold leading-7"
              >
                {getRanges(homeDetails.garageRanges)}
              </Copy>
            </div>
          </div>
        )}
      </div>
    </>
  );

  return <> {isMobile ? renderHomeDetailsMobile() : renderHomeDetails()}</>;
};

export default CommunityProductOverviewHomeDetails;
